// kapigen version 0.1.34
// eslint-disable
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { google } from "../../google";
import { createClient } from "../../../requestClientInternal";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3 } from "../../common";
import { CompetitionDatabundleTypeWireFormat3 as KaggleSdkCompetitionsCompetitionDatabundleTypeWireFormat3, CompetitionMetricVersionWireFormat3 as KaggleSdkCompetitionsCompetitionMetricVersionWireFormat3, EvaluationAlgorithmWireFormat3 as KaggleSdkCompetitionsEvaluationAlgorithmWireFormat3, HostSegmentWireFormat3 as KaggleSdkCompetitionsHostSegmentWireFormat3, SubmissionGroupWireFormat3 as KaggleSdkCompetitionsSubmissionGroupWireFormat3, SubmissionSortByWireFormat3 as KaggleSdkCompetitionsSubmissionSortByWireFormat3, SubmissionStatusWireFormat3 as KaggleSdkCompetitionsSubmissionStatusWireFormat3 } from "..";
import { CompetitionDatabundleVersionWireFormat3 as KaggleSdkDatasetsCompetitionDatabundleVersionWireFormat3 } from "../../datasets";
import { NewTopicDtoWireFormat3 as KaggleSdkDiscussionsNewTopicDtoWireFormat3, TopicListDtoWireFormat3 as KaggleSdkDiscussionsTopicListDtoWireFormat3 } from "../../discussions";
import { TagListWireFormat3 as KaggleSdkTagsTagListWireFormat3 } from "../../tags";
import { UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3 } from "../../users";
// namespace Kaggle.Sdk.Competitions.Legacy:
export var HostChecklistItem;
(function(HostChecklistItem) {
    var ChecklistItemType;
    (function(ChecklistItemType) {
        ChecklistItemType["UNSPECIFIED"] = "unspecified";
        ChecklistItemType["CREATED"] = "created";
        ChecklistItemType["HAS_VALID_DEADLINE"] = "hasValidDeadline";
        ChecklistItemType["HAS_RULES_PAGE_CONTENT"] = "hasRulesPageContent";
        ChecklistItemType["HAS_DATA_PAGE_CONTENT"] = "hasDataPageContent";
        ChecklistItemType["HAS_OVERVIEW_CONTENT"] = "hasOverviewContent";
        ChecklistItemType["HAS_VALID_METRIC"] = "hasValidMetric";
        ChecklistItemType["HAS_SOLUTION"] = "hasSolution";
        ChecklistItemType["HAS_SOLUTION_AND_SUBMISSION_SCHEMAS"] = "hasSolutionAndSubmissionSchemas";
        ChecklistItemType["HAS_SANDBOX_SUBMISSION"] = "hasSandboxSubmission";
        ChecklistItemType["HAS_DATASET"] = "hasDataset";
        ChecklistItemType["HAS_TAGS"] = "hasTags";
        ChecklistItemType["HAS_IMAGES"] = "hasImages";
        ChecklistItemType["HAS_INVITE"] = "hasInvite";
    })(ChecklistItemType = HostChecklistItem.ChecklistItemType || (HostChecklistItem.ChecklistItemType = {}));
    var ChecklistItemTypeWireFormat3 = HostChecklistItem.ChecklistItemTypeWireFormat3 = {
        fromJson: function fromJson(wireFormat) {
            switch(wireFormat){
                case "CHECKLIST_ITEM_TYPE_UNSPECIFIED":
                default:
                    return ChecklistItemType.UNSPECIFIED;
                case "CREATED":
                    return ChecklistItemType.CREATED;
                case "HAS_VALID_DEADLINE":
                    return ChecklistItemType.HAS_VALID_DEADLINE;
                case "HAS_RULES_PAGE_CONTENT":
                    return ChecklistItemType.HAS_RULES_PAGE_CONTENT;
                case "HAS_DATA_PAGE_CONTENT":
                    return ChecklistItemType.HAS_DATA_PAGE_CONTENT;
                case "HAS_OVERVIEW_CONTENT":
                    return ChecklistItemType.HAS_OVERVIEW_CONTENT;
                case "HAS_VALID_METRIC":
                    return ChecklistItemType.HAS_VALID_METRIC;
                case "HAS_SOLUTION":
                    return ChecklistItemType.HAS_SOLUTION;
                case "HAS_SOLUTION_AND_SUBMISSION_SCHEMAS":
                    return ChecklistItemType.HAS_SOLUTION_AND_SUBMISSION_SCHEMAS;
                case "HAS_SANDBOX_SUBMISSION":
                    return ChecklistItemType.HAS_SANDBOX_SUBMISSION;
                case "HAS_DATASET":
                    return ChecklistItemType.HAS_DATASET;
                case "HAS_TAGS":
                    return ChecklistItemType.HAS_TAGS;
                case "HAS_IMAGES":
                    return ChecklistItemType.HAS_IMAGES;
                case "HAS_INVITE":
                    return ChecklistItemType.HAS_INVITE;
            }
        }
    };
})(HostChecklistItem || (HostChecklistItem = {}));
export var AddHostUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAddHostUserResponse = {};
export var AddHostUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddHostUserResponse, wireFormat);
        return message;
    }
};
var defaultBackgroundOperation = {
    id: "",
    name: "",
    done: false
};
export var BackgroundOperationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBackgroundOperation, wireFormat);
        return message;
    }
};
var defaultColumnDefinition = {
    name: "",
    parsingDataType: ""
};
export var ColumnDefinitionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnDefinition, wireFormat);
        return message;
    }
};
var defaultColumnMapping = {
    columnMappings: {},
    columnDefinitions: []
};
export var ColumnMappingWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnMapping, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnMappings) {
            message.columnMappings = {};
            Object.entries(wireFormat.columnMappings).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.columnMappings[key] = ColumnMappingValueWireFormat3.fromJson(value);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnDefinitions) {
            message.columnDefinitions = wireFormat.columnDefinitions.map(function(i) {
                return ColumnDefinitionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultColumnMappingValue = {};
export var ColumnMappingValueWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnMappingValue, wireFormat);
        return message;
    }
};
var defaultCompetitionDto = {
    competitionId: 0,
    hasAcceptedRules: false,
    totalTeams: 0,
    isInClass: false,
    canEdit: false,
    hasLimitedParticipation: false,
    numScoredSubmissions: 0,
    maxDailySubmissions: 0,
    totalEntries: 0,
    countsTowardsRanking: false,
    countsTowardsTiers: false,
    isCreatingCompetition: false,
    pages: [],
    rerunDatabundleVersions: [],
    submissionsAreDisabled: false,
    hasLeaderboard: false,
    isPrivate: false,
    hasKernels: false,
    hasSolutionFile: false,
    userRankMultiplier: 0,
    needsPhoneVerification: false,
    isCompetitionHost: false,
    hostSegments: [],
    canParticipate: false,
    isCompetitionPending: false,
    competitionHasLaunched: false,
    competitionHasEnded: false,
    mergerDeadlineHasPassed: false,
    newEntrantDeadlineHasPassed: false,
    onlyAllowKernelSubmissions: false,
    rulesRequired: false,
    usesSynchronousReruns: false,
    disableKernelsPublishing: false,
    isOngoingCompetition: false
};
export var CompetitionDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEnabled) {
            message.dateEnabled = new Date(wireFormat.dateEnabled);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mergerDeadline) {
            message.mergerDeadline = new Date(wireFormat.mergerDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newEntrantDeadline) {
            message.newEntrantDeadline = new Date(wireFormat.newEntrantDeadline);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rewardQuantity) != undefined) {
            message.rewardQuantity = Number(wireFormat.rewardQuantity);
        }
        if (wireFormat) {
            message.hostSegment = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.hostSegment);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rules) {
            message.rules = CompetitionPageWireFormat3.fromJson(wireFormat.rules);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussion) {
            message.discussion = KaggleSdkDiscussionsTopicListDtoWireFormat3.fromJson(wireFormat.discussion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newTopic) {
            message.newTopic = KaggleSdkDiscussionsNewTopicDtoWireFormat3.fromJson(wireFormat.newTopic);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxDailySubmissionsResetDate) {
            message.maxDailySubmissionsResetDate = new Date(wireFormat.maxDailySubmissionsResetDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.team) {
            message.team = CompetitionTeamDtoWireFormat3.fromJson(wireFormat.team);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationAlgorithm) {
            message.evaluationAlgorithm = KaggleSdkCompetitionsEvaluationAlgorithmWireFormat3.fromJson(wireFormat.evaluationAlgorithm);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CompetitionPageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rerunDatabundleVersions) {
            message.rerunDatabundleVersions = wireFormat.rerunDatabundleVersions.map(function(i) {
                return KaggleSdkDatasetsCompetitionDatabundleVersionWireFormat3.fromJson(i);
            });
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userRankMultiplier) != undefined) {
            message.userRankMultiplier = Number(wireFormat.userRankMultiplier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hostSegments) {
            message.hostSegments = wireFormat.hostSegments.map(function(i) {
                return HostSegmentItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = KaggleSdkTagsTagListWireFormat3.fromJson(wireFormat.categories);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionHostClaims) {
            message.competitionHostClaims = CompetitionHostClaimsWireFormat3.fromJson(wireFormat.competitionHostClaims);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLeaderboardReleaseDate) {
            message.privateLeaderboardReleaseDate = new Date(wireFormat.privateLeaderboardReleaseDate);
        }
        return message;
    }
};
var defaultCompetitionDtoComputedFields = {
    isOngoingCompetition: false
};
export var CompetitionDtoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionDtoComputedFields, wireFormat);
        return message;
    }
};
var defaultCompetitionHostClaims = {
    readSettings: false,
    writeSettings: false,
    writeDescriptions: false,
    writeDeadline: false,
    readSubmissions: false,
    writeSubmissions: false,
    invalidateSubmissions: false,
    rescoreSubmissions: false,
    readEvaluation: false,
    writeEvaluation: false,
    writeTeamVisibility: false,
    updateCategory: false,
    launchCompetition: false,
    writeBenchmarks: false,
    isCommunitySimulation: false
};
export var CompetitionHostClaimsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionHostClaims, wireFormat);
        return message;
    }
};
var defaultCompetitionPage = {
    content: "",
    mimeType: "",
    name: ""
};
export var CompetitionPageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionPage, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCompetitionTeamDto = {
    id: 0,
    canCreateMerger: false,
    members: []
};
export var CompetitionTeamDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.members) {
            message.members = wireFormat.members.map(function(i) {
                return CompetitionTeamMemberDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultCompetitionTeamInfoDto = {
    id: 0,
    entries: 0,
    entriesSizeInBytes: 0,
    isHidden: false
};
export var CompetitionTeamInfoDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamInfoDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.entriesSizeInBytes) {
            message.entriesSizeInBytes = parseInt(wireFormat.entriesSizeInBytes);
        }
        return message;
    }
};
var defaultCompetitionTeamMemberDto = {
    userId: 0,
    isTeamLeader: false
};
export var CompetitionTeamMemberDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamMemberDto, wireFormat);
        return message;
    }
};
var defaultEvaluationInfo = {
    parameters: [],
    canViewMetric: false,
    competitionHasSolution: false
};
export var EvaluationInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metric) {
            message.metric = KaggleSdkCompetitionsEvaluationAlgorithmWireFormat3.fromJson(wireFormat.metric);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metricVersion) {
            message.metricVersion = KaggleSdkCompetitionsCompetitionMetricVersionWireFormat3.fromJson(wireFormat.metricVersion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parameters) {
            message.parameters = wireFormat.parameters.map(function(i) {
                return EvaluationMetricParameterWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionColumnMapping) {
            message.solutionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.solutionColumnMapping);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissionColumnMapping) {
            message.submissionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.submissionColumnMapping);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionInfo) {
            message.solutionInfo = SolutionInfoWireFormat3.fromJson(wireFormat.solutionInfo);
        }
        return message;
    }
};
var defaultEvaluationMetricParameter = {
    name: "",
    type: "",
    value: ""
};
export var EvaluationMetricParameterWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationMetricParameter, wireFormat);
        return message;
    }
};
export var GetBackgroundOperationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCompetitionDatabundleVersionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
            wireFormat.competitionDatabundleType = KaggleSdkCompetitionsCompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
        }
        return wireFormat;
    }
};
var defaultGetCompetitionDatabundleVersionsResponse = {
    databundleVersions: []
};
export var GetCompetitionDatabundleVersionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionDatabundleVersionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersions) {
            message.databundleVersions = wireFormat.databundleVersions.map(function(i) {
                return KaggleSdkDatasetsCompetitionDatabundleVersionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetHostChecklistRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetHostClaimsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetHostEvaluationInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetMostRecentSubmissionStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetMostRecentSubmissionStatusResponse = {};
export var GetMostRecentSubmissionStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetMostRecentSubmissionStatusResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
            message.submission = LegacySubmissionExtendedWireFormat3.fromJson(wireFormat.submission);
        }
        return message;
    }
};
var defaultHostChecklist = {
    isCompetitionPending: false,
    children: []
};
export var HostChecklistWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostChecklist, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return HostChecklistItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultHostChecklistItem = {
    ok: false,
    title: "",
    message: "",
    url: ""
};
export var HostChecklistItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostChecklistItem, wireFormat);
        if (wireFormat) {
            message.type = HostChecklistItem.ChecklistItemTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultHostEvaluationInfo = {};
export var HostEvaluationInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostEvaluationInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationInfo) {
            message.evaluationInfo = EvaluationInfoWireFormat3.fromJson(wireFormat.evaluationInfo);
        }
        return message;
    }
};
var defaultHostSegmentItem = {};
export var HostSegmentItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostSegmentItem, wireFormat);
        if (wireFormat) {
            message.value = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.value);
        }
        return message;
    }
};
var defaultHostUserAvatar = {};
export var HostUserAvatarWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostUserAvatar, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.user);
        }
        return message;
    }
};
export var InvalidateSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LaunchCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.futureTime) {
            wireFormat.futureTime = message.futureTime.toISOString();
        }
        return wireFormat;
    }
};
var defaultLaunchCompetitionResponse = {};
export var LaunchCompetitionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLaunchCompetitionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.launchTime) {
            message.launchTime = new Date(wireFormat.launchTime);
        }
        return message;
    }
};
export var LegacyColumnMappingWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyGetCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyListTeamsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = CompetitionTeamSortByWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.teamType) {
            wireFormat.teamType = TeamTypeWireFormat3.toJson(message.teamType);
        }
        return wireFormat;
    }
};
var defaultLegacyListTeamsResponse = {
    teamsList: [],
    hasMoreData: false,
    totalTeams: 0,
    totalSubmissions: 0
};
export var LegacyListTeamsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyListTeamsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamsList) {
            message.teamsList = wireFormat.teamsList.map(function(i) {
                return CompetitionTeamInfoDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultLegacySandboxSubmission = {
    id: 0,
    name: "",
    isBenchmark: false,
    downloadUrl: ""
};
export var LegacySandboxSubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacySandboxSubmission, wireFormat);
        if (wireFormat) {
            message.submissionStatus = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.submissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        return message;
    }
};
var defaultLegacySubmissionExtended = {
    name: "",
    userDisplayName: ""
};
export var LegacySubmissionExtendedWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacySubmissionExtended, wireFormat);
        if (wireFormat) {
            message.submissionStatus = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.submissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        return message;
    }
};
var defaultLegacyTeamSubmission = {
    id: 0,
    isSelected: false,
    isChecked: false
};
export var LegacyTeamSubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyTeamSubmission, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        return message;
    }
};
export var ListHostUsersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListHostUsersResponse = {
    hosts: []
};
export var ListHostUsersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListHostUsersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hosts) {
            message.hosts = wireFormat.hosts.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListMySubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = KaggleSdkCompetitionsSubmissionSortByWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = KaggleSdkCompetitionsSubmissionGroupWireFormat3.toJson(message.group);
        }
        return wireFormat;
    }
};
var defaultListMySubmissionsResponse = {
    submissions: []
};
export var ListMySubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListMySubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissions) {
            message.submissions = wireFormat.submissions.map(function(i) {
                return LegacyTeamSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListSandboxSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListSandboxSubmissionsResponse = {
    sandboxSubmissions: []
};
export var ListSandboxSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSandboxSubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sandboxSubmissions) {
            message.sandboxSubmissions = wireFormat.sandboxSubmissions.map(function(i) {
                return LegacySandboxSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListTeamSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTeamSubmissionsResponse = {
    teamSubmissions: []
};
export var ListTeamSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTeamSubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamSubmissions) {
            message.teamSubmissions = wireFormat.teamSubmissions.map(function(i) {
                return LegacyTeamSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var RemoveHostUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SearchHostUsersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchHostUsersResponse = {
    users: []
};
export var SearchHostUsersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchHostUsersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.users) {
            message.users = wireFormat.users.map(function(i) {
                return HostUserAvatarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SetEvaluationMetricParametersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSolutionInfo = {
    hasRaw: false,
    hasDerived: false
};
export var SolutionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSolutionInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rawFileSizeBytes) {
            message.rawFileSizeBytes = parseInt(wireFormat.rawFileSizeBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.uploadDate) {
            message.uploadDate = new Date(wireFormat.uploadDate);
        }
        return message;
    }
};
export var ToggleTeamVisibilityRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateCompetitionSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.hostSegment) {
            wireFormat.hostSegment = KaggleSdkCompetitionsHostSegmentWireFormat3.toJson(message.hostSegment);
        }
        if (message === null || message === void 0 ? void 0 : message.deadline) {
            wireFormat.deadline = message.deadline.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.privateLeaderboardReleaseDate) {
            wireFormat.privateLeaderboardReleaseDate = message.privateLeaderboardReleaseDate.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.dateEnabled) {
            wireFormat.dateEnabled = message.dateEnabled.toISOString();
        }
        return wireFormat;
    }
};
export var UpdateImagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.header) {
            wireFormat.header = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.header);
        }
        if (message === null || message === void 0 ? void 0 : message.thumbnail) {
            wireFormat.thumbnail = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.thumbnail);
        }
        return wireFormat;
    }
};
var defaultUpdateImagesResponse = {};
export var UpdateImagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateImagesResponse, wireFormat);
        return message;
    }
};
export var UpdateOverviewRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.overviewPages) {
            wireFormat.overviewPages = message.overviewPages.map(function(i) {
                return CompetitionPageWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultUpdateOverviewResponse = {
    pages: []
};
export var UpdateOverviewResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateOverviewResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CompetitionPageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.page) {
            wireFormat.page = CompetitionPageWireFormat3.toJson(message.page);
        }
        return wireFormat;
    }
};
export var UpdateSolutionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.columnMapping) {
            wireFormat.columnMapping = LegacyColumnMappingWireFormat3.toJson(message.columnMapping);
        }
        return wireFormat;
    }
};
export var UpdateSubmissionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.columnMapping) {
            wireFormat.columnMapping = LegacyColumnMappingWireFormat3.toJson(message.columnMapping);
        }
        return wireFormat;
    }
};
export var UpdateTeamVisibilityRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var WaitBackgroundOperationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CompetitionPageError;
(function(CompetitionPageError) {
    CompetitionPageError["UNSPECIFIED"] = "unspecified";
    CompetitionPageError[// Page name has special meaning (e.g. "rules" or "data") and is reserved.
    "RESERVED_NAME"] = "reservedName";
    CompetitionPageError[// Page name is already in use.
    "DUPLICATE_NAME"] = "duplicateName";
    CompetitionPageError["CONCURRENT_EDIT"] = "concurrentEdit";
})(CompetitionPageError || (CompetitionPageError = {}));
export var CompetitionTeamSortBy;
(function(CompetitionTeamSortBy) {
    CompetitionTeamSortBy["RANK"] = "rank";
    CompetitionTeamSortBy["PUBLIC_SCORE_ASC"] = "publicScoreAsc";
    CompetitionTeamSortBy["PUBLIC_SCORE_DESC"] = "publicScoreDesc";
    CompetitionTeamSortBy["PRIVATE_SCORE_ASC"] = "privateScoreAsc";
    CompetitionTeamSortBy["PRIVATE_SCORE_DESC"] = "privateScoreDesc";
})(CompetitionTeamSortBy || (CompetitionTeamSortBy = {}));
export var CompetitionTeamSortByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionTeamSortBy.RANK:
            case 0:
            default:
                return "RANK";
            case CompetitionTeamSortBy.PUBLIC_SCORE_ASC:
            case 1:
                return "PUBLIC_SCORE_ASC";
            case CompetitionTeamSortBy.PUBLIC_SCORE_DESC:
            case 2:
                return "PUBLIC_SCORE_DESC";
            case CompetitionTeamSortBy.PRIVATE_SCORE_ASC:
            case 3:
                return "PRIVATE_SCORE_ASC";
            case CompetitionTeamSortBy.PRIVATE_SCORE_DESC:
            case 4:
                return "PRIVATE_SCORE_DESC";
        }
    }
};
export var TeamType;
(function(TeamType) {
    TeamType["UNSPECIFIED"] = "unspecified";
    TeamType["RANKED"] = "ranked";
    TeamType["UNRANKED"] = "unranked";
})(TeamType || (TeamType = {}));
export var TeamTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TeamType.UNSPECIFIED:
            case 0:
            default:
                return "TEAM_TYPE_UNSPECIFIED";
            case TeamType.RANKED:
            case 1:
                return "TEAM_TYPE_RANKED";
            case TeamType.UNRANKED:
            case 2:
                return "TEAM_TYPE_UNRANKED";
        }
    }
};
// Loosely based on
// https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
// Prefixed with "Background" to avoid conflict with that one.
// Has historically only been used by Competitions but could eventually be made
// into an official (non-Legacy) service.
export var competitionsLegacyClient = {
    legacyCompetitionBackgroundService: {
        getBackgroundOperation: createClient(GetBackgroundOperationRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionBackgroundService/GetBackgroundOperation"),
        waitBackgroundOperation: createClient(WaitBackgroundOperationRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionBackgroundService/WaitBackgroundOperation")
    },
    legacyCompetitionHostService: {
        // Adds a user to the competition's admin group.
        addHostUser: createClient(AddHostUserRequestWireFormat3, AddHostUserResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/AddHostUser"),
        // Gets details to render the host checklist page.
        getHostChecklist: createClient(GetHostChecklistRequestWireFormat3, HostChecklistWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostChecklist"),
        // Gets claims/permissions that inform the host what they can do (and adjust
        // the UI appropriately).
        getHostClaims: createClient(GetHostClaimsRequestWireFormat3, CompetitionHostClaimsWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostClaims"),
        getHostEvaluationInfo: createClient(GetHostEvaluationInfoRequestWireFormat3, HostEvaluationInfoWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostEvaluationInfo"),
        invalidateSubmissions: createClient(InvalidateSubmissionsRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/InvalidateSubmissions"),
        // Launch the competition (or set it to be launched in the future) so that it
        // becomes visible to participants.
        launchCompetition: createClient(LaunchCompetitionRequestWireFormat3, LaunchCompetitionResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/LaunchCompetition"),
        // Lists all of the users that are members of the competition's admin group.
        listHostUsers: createClient(ListHostUsersRequestWireFormat3, ListHostUsersResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/ListHostUsers"),
        // Removes a user from the competition's admin group.
        removeHostUser: createClient(RemoveHostUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/RemoveHostUser"),
        // Searches for users that could be added as a host to a competition's admin
        // group.
        searchHostUsers: createClient(SearchHostUsersRequestWireFormat3, SearchHostUsersResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SearchHostUsers"),
        setEvaluationMetricParameters: createClient(SetEvaluationMetricParametersRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SetEvaluationMetricParameters"),
        // Like UpdateTeamVisibility above, but for synchronously updating a single
        // team Should be migrated to the new world after the team state refactor and
        // the new BE pattern is established
        toggleTeamVisibility: createClient(ToggleTeamVisibilityRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/ToggleTeamVisibility"),
        // Saves the data on the "Settings" page.
        // (-- aip.dev/not-precedent: Not returning anything on Update to match legacy
        // API.)
        updateCompetitionSettings: createClient(UpdateCompetitionSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateCompetitionSettings"),
        // Updates the header and/or thumbnail images associated with the competition.
        updateImages: createClient(UpdateImagesRequestWireFormat3, UpdateImagesResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateImages"),
        // Updates the competition overview pages.
        updateOverview: createClient(UpdateOverviewRequestWireFormat3, UpdateOverviewResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateOverview"),
        // Updates a single page.
        updatePage: createClient(UpdatePageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdatePage"),
        updateSolutionColumnMapping: createClient(UpdateSolutionColumnMappingRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateSolutionColumnMapping"),
        updateSubmissionColumnMapping: createClient(UpdateSubmissionColumnMappingRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateSubmissionColumnMapping"),
        updateTeamVisibility: createClient(UpdateTeamVisibilityRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateTeamVisibility")
    },
    legacyCompetitionService: {
        getCompetition: createClient(LegacyGetCompetitionRequestWireFormat3, CompetitionDtoWireFormat3, "competitions.legacy.LegacyCompetitionService/GetCompetition"),
        getCompetitionDatabundleVersions: createClient(GetCompetitionDatabundleVersionsRequestWireFormat3, GetCompetitionDatabundleVersionsResponseWireFormat3, "competitions.legacy.LegacyCompetitionService/GetCompetitionDatabundleVersions"),
        listTeams: createClient(LegacyListTeamsRequestWireFormat3, LegacyListTeamsResponseWireFormat3, "competitions.legacy.LegacyCompetitionService/ListTeams")
    },
    legacySubmissionService: {
        // Gets the status of the current user's most recent submission.
        getMostRecentSubmissionStatus: createClient(GetMostRecentSubmissionStatusRequestWireFormat3, GetMostRecentSubmissionStatusResponseWireFormat3, "competitions.legacy.LegacySubmissionService/GetMostRecentSubmissionStatus"),
        listMySubmissions: createClient(ListMySubmissionsRequestWireFormat3, ListMySubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListMySubmissions"),
        listSandboxSubmissions: createClient(ListSandboxSubmissionsRequestWireFormat3, ListSandboxSubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListSandboxSubmissions"),
        listTeamSubmissions: createClient(ListTeamSubmissionsRequestWireFormat3, ListTeamSubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListTeamSubmissions")
    }
};
